import makeStateFilter from '../../make-state-filter';

import { stateFilter as parentStateFilter } from '../reducer.metadata';

const namespace = 'paging';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
